import {getGTINDetails} from '@/services/PromotionsService/promotionProductSelection'
import {DEFAULT_TABLE_PAGE_SIZE} from '@/utils/constants/commonConstants'
import {useQuery} from '@tanstack/react-query'

export const useGetGTINDetails = (gtinId, page = 0, size = DEFAULT_TABLE_PAGE_SIZE) => {
  const query = useQuery({
    queryKey: ['GTIN_DETAILS', page, size, gtinId],
    queryFn: () => getGTINDetails(gtinId, {page, size}),
    enabled: !!gtinId, // Only run the query if gtinId is provided
  })

  return query
}
